import debounce from 'lodash.debounce';

export default class SummaryPositions {
  init() {
    this.summaryElement = document.querySelector('.post-summary');

    if (!this.summaryElement) {
      return;
    }

    this.summaryContainer = this.summaryElement.querySelector(
      '.post-summary__list'
    );

    if (!this.summaryContainer) {
      return;
    }

    this.scrollTop = window.scrollY || window.pageYOffset;

    this.summaryElements = Array.from(
      this.summaryContainer.querySelectorAll('[data-id]')
    );
    this.summaryElementsPositions = [];

    window.addEventListener(
      'resize',
      debounce(() => {
        this.updateListenedElements();
      }, 300),
      window.supportPassive
    );

    window.addEventListener(
      'scroll',
      () => {
        this.scrollTop = window.scrollY || window.pageYOffset;

        this.listenToRelativeState(this.scrollTop);
      },
      window.supportPassive
    );

    this.itemLinks = Array.from(
      this.summaryElement.querySelectorAll('.post-summary__list-item-link')
    );

    for (let itemLink of this.itemLinks) {
      itemLink.addEventListener(
        'click',
        () => {
          this.toggleBUtton.classList.remove('is-open');
          this.summaryElement.classList.remove('is-open');
        },
        window.supportPassive
      );
    }

    this.toggleBUtton = this.summaryElement.querySelector(
      '.post-summary__toggle-button'
    );

    if (this.toggleBUtton) {
      this.toggleBUtton.addEventListener(
        'click',
        () => {
          const force = !this.toggleBUtton.classList.contains('is-open');

          this.toggleBUtton.classList.toggle('is-open', force);
          this.summaryElement.classList.toggle('is-open', force);
        },
        window.supportPassive
      );
    }

    this.updateListenedElements();
    this.listenToRelativeState(this.scrollTop);
  }

  updateListenedElements() {
    this.summaryElementsPositions = [];

    this.summaryElements.forEach((heading, index) => {
      const positions = [];

      let dataId = heading.getAttribute('data-id');
      let realHeading = document.getElementById(dataId);
      const currentElementPosition =
        realHeading.getBoundingClientRect().top + this.scrollTop;

      positions.push(currentElementPosition);

      const nextElement = this.summaryElements[index + 1];
      let nextElementPosition =
        document.getElementById('end-of-content').getBoundingClientRect().top +
        this.scrollTop;

      if (nextElement) {
        dataId = nextElement.getAttribute('data-id');
        let realNextHeading = document.getElementById(dataId);

        nextElementPosition =
          realNextHeading.getBoundingClientRect().top + this.scrollTop;
      }

      positions.push(nextElementPosition);

      this.summaryElementsPositions.push(positions);
    });
  }

  listenToRelativeState(position = 0) {
    let currentElement = undefined;

    const viewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );

    position += viewportHeight * 0.75; // offset of the 3/4 screen height

    this.summaryElementsPositions.forEach((element, index) => {
      let percentage =
        ((position - element[0]) / (element[1] - element[0])) * 100;

      percentage = Math.round(percentage);

      if (0 < percentage && 100 >= percentage) {
        this.summaryElements[index].style.backgroundImage =
          `linear-gradient(90deg, rgba(63, 180, 152, 0.4) ${percentage}%, #f7f7f7 ${percentage}%)`;

        currentElement = this.summaryElements[index];
      } else if (0 < percentage && 100 < percentage) {
        this.summaryElements[index].style.backgroundImage =
          'linear-gradient(90deg, rgba(63, 180, 152, 0.4) 100%, #f7f7f7 100%)';

        // If is not the last one, hide it
        if (index !== this.summaryElements.length - 1) {
          this.summaryElements[index].parentNode.classList.remove('is-current');
        } else {
          currentElement =
            this.summaryElements[this.summaryElements.length - 1];
        }
      } else {
        this.summaryElements[index].style.backgroundImage =
          'linear-gradient(90deg, rgba(63, 180, 152, 0.4) 0%, #f7f7f7 0%)';

        // If is not the first, hide it
        if (index !== 0) {
          this.summaryElements[index].parentNode.classList.remove('is-current');
        } else {
          currentElement = this.summaryElements[index];
        }
      }
    });

    // Show the current one
    if (currentElement) {
      currentElement.parentNode.classList.add('is-current');
    }
  }
}
